/**
 * @fileoverview Two facts about how somebody arrived, which the tips read: whether the
 * account is new enough to be greeted, and whether they came in on a beta
 * link.
 *
 * The welcome itself is on Today now (TodayPostcode, and the first step from
 * the tips). It was a screen over everything that asked for the postcode.
 *
 * Where: TipsContext (isBetaArrival).
 * API: none.
 * Settings: none.
 *
 * @module welcome/arrival
 */

/**
 * `?beta=1` on any URL. Read once, on the way in; the tips keep it on the account.
 *
 * @returns True when the address carries ?beta=1.
 */
export function isBetaArrival(): boolean {
  try {
    return new URLSearchParams(window.location.search).get('beta') === '1';
  } catch {
    return false;
  }
}
